import { SerializedStyles, css } from '@emotion/react';
import { Cell } from '@tanstack/react-table';
import { memo } from 'react';
import { QuantileDistribution, AverageChangeRow } from 'redux/schemas/app/analytics';
import { HeaderProps } from 'shared/components/nv-table';

interface ReportColumnHeaderProps<T> extends HeaderProps<T> {
  height: string | number;
  getColumnStyle: (headerIndex: number) => SerializedStyles;
}

export const ReportColumnHeader = memo(
  ({ headerGroup, className, height, getColumnStyle }: ReportColumnHeaderProps<any>) => (
    <div
      key={headerGroup.id}
      css={css`height: ${height}px;`}
      className={`${className} bg-gray-6`}
    >
      {headerGroup.headers.map(header => {
        const { header: headerTitle } = header.column.columnDef;
        const columnStyle = getColumnStyle(header.index);

        return (
          <div
            className='d-flex align-items-center label text-black pl-2'
            css={columnStyle}
            key={header.id}
          >
            {headerTitle}
          </div>
        );
      })}
    </div>
  ),
) as <T>(props: ReportColumnHeaderProps<T>) => JSX.Element;

export const QuestionCell: React.FC<{
  cell: Cell<QuantileDistribution | AverageChangeRow, string>;
  css: SerializedStyles
}> = memo(({ cell, css: cellStyles }) => (
  <div
    css={css`
      ${cellStyles}
      width: 560px;
    `}
    className='pl-2 py-3'
  >
    {cell.getValue()}
  </div>
));

